import { useTenantContext } from '../tenant-context';

export const useFabricProfileDirectoryUrl = (): string => {
	const tenantContext = useTenantContext();

	return (tenantContext && tenantContext.fabricPfDirUrl) || '';
};
